import(/* webpackMode: "eager" */ "/app/apps/admin/app/error.tsx");
